module.exports = __webpack_public_path__ + "img/birch.be5030ca.webp";